<div class="card step-card flex flex-column">
  <div>
    <form [formGroup]="assetMeasurementsForm" *ngIf="assetMeasurementsForm">
      <div class="mb-3 flex flex-column sm:flex-row justify-content-end">
        <button
          [label]="'new.sensor' | transloco"
          (click)="addMeasurement()"
          pButton
          pRipple
          icon="pi pi-plus"
          iconPos="left"
        ></button>
        <button
          [label]="'misc.copyFromAsset' | transloco"
          (click)="displayCopyFromAsset = true"
          pButton
          pRipple
          class="sm:ml-2 mt-2 sm:mt-0"
          icon="pi pi-copy"
          iconPos="left"
        ></button>
      </div>
      <div *ngIf="rowsForm.controls.length > 0" class="my-5" formArrayName="assetMeasurements">
        <p-table
          *ngIf="rowsForm"
          [value]="rowsForm.controls"
          [responsive]="true"
          breakpoint="1800px"
          styleClass="p-datatable-striped"
        >
          <ng-template pTemplate="header">
            <tr>
              <th>{{'attribute.name' | transloco}} (*)</th>
              <th>{{'attribute.description' | transloco}}</th>
              <th>{{'attribute.alias' | transloco}}</th>
              <th>{{'model.measurementType' | transloco}} (*)</th>
              <th>{{'attribute.sampleRate' | transloco}}</th>
              <th class="w-8rem"></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-control let-rowIndex="rowIndex">
            <tr [formGroupName]="rowIndex" class="fadein">
              <td>
                <span class="p-column-title">{{'attribute.name' | transloco}} (*)</span>
                <input pInputText type="text" formControlName="name">
              </td>
              <td>
                <span class="p-column-title">{{'attribute.description' | transloco}}</span>
                <input pInputText type="text" formControlName="description">
              </td>
              <td>
                <span class="p-column-title">{{'attribute.alias' | transloco}}</span>
                <input pInputText type="text" formControlName="alias">
              </td>
              <td>
                <span class="p-column-title">{{'model.measurementType' | transloco}} (*)</span>
                <p-dropdown
                  [placeholder]="'select.type' | transloco"
                  [options]="measurementTypes"
                  formControlName="measurementType"
                  optionLabel="sensor"
                  styleClass="dropdown-width-md"
                ></p-dropdown>
              </td>
              <td>
                <span class="p-column-title">{{'attribute.sampleRate' | transloco}}</span>
                <input pInputText type="number" formControlName="sampleRate">
              </td>
              <td class="text-center">
                <span class="p-column-title">{{'common.delete' | transloco}}</span>
                <button
                  (click)="onRowDelete(rowIndex)"
                  pButton
                  pRipple
                  class="p-button-rounded p-button-text p-button-danger"
                  type="button"
                  icon="pi pi-trash"
                ></button>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
      <div *ngIf="rowsForm.controls.length === 0" class="font-italic text-center mt-7">
        {{'empty.measurements' | transloco}}
      </div>
    </form>
  </div>
  <div class="mt-auto">
    <div class="flex flex-column sm:flex-row justify-content-between">
      <div class="flex justify-content-between sm:justify-content-start sm:flex-order-1">
        <button
          [label]="'common.previous' | transloco"
          (click)="previousStep()"
          pButton
          pRipple
          class="flex-1 sm:flex-none"
          icon="pi pi-angle-left"
          iconPos="left"
        ></button>
        <button
          [label]="'common.next' | transloco"
          (click)="nextStep()"
          [disabled]="!assetMeasurementsForm?.valid"
          pButton
          pRipple
          class="ml-2 flex-1 sm:flex-none"
          icon="pi pi-angle-right"
          iconPos="right"
        ></button>
      </div>
      <button
        [label]="'common.cancel' | transloco"
        (click)="cancelAction()"
        pButton
        pRipple
        class="p-button-danger mt-2 sm:mt-0 sm:flex-order-0"
      ></button>
    </div>
  </div>
</div>
<app-asset-selector
  [(visible)]="displayCopyFromAsset"
  [tenant]="tenant"
  [actionButtons]="copyFromAssetActions"
></app-asset-selector>
